

import Vue from 'vue'
import Component from "vue-class-component";
import {Watch} from "vue-property-decorator";
import {IOnOffHandlers} from "bonomo/dist";
import {namespace} from "vuex-class";
import {IErrors} from "@/model/IErrors";
import {ICourier, ICourierCatalog} from "@/model/Courier/courierInterfaces";
import {countries} from "@/locale/countries";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";

const courierModule = namespace("courierModule");

@Component({
  components: {SimpleConfirmationDialog},
})
export default class CourierCatalogByCountry extends Vue {

  @courierModule.Getter('couriers')
  protected couriers!: ICourier[];
  @courierModule.Getter('catalogs')
  protected catalogs!: ICourierCatalog[];
  @courierModule.Getter('errors')
  protected errors!: IErrors;

  protected readonly countries = countries;
  protected countryId: number|null = null;
  protected courierIdToAdd: number|null = null;
  protected rows: ICourierCatalog[] = [];
  protected busy: boolean = false;
  protected removeShowing: boolean = false;
  protected removingRow: ICourierCatalog|null = null;
  private subscribes: IOnOffHandlers = {};

  protected get countryName(): string {
    const country = countries.find(each => each.value === this.countryId);
    return country ? country.text : '';
  }

  protected get addableCouriers(): ICourier[] {
    const added = this.rows.map(each => each.courier_id);
    return this.couriers
      .filter(each => added.indexOf(each.id) === -1)
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.loadData,
      'backend.call.OK.courierCatalogsLoaded': this.onLoaded,
      'backend.call.KO.courierCatalogsLoaded': this.onLoaded,
      'backend.call.OK.courierCatalogSaved': this.onChangedOK,
      'backend.call.KO.courierCatalogSaved': this.loadCatalogs,
      'backend.call.OK.courierCatalogDeleted': this.onChangedOK,
      'backend.call.KO.courierCatalogDeleted': this.loadCatalogs,
      'backend.call.OK.courierCatalogsReordered': this.onLoaded,
      'backend.call.KO.courierCatalogsReordered': this.loadCatalogs,
    });
    this.$store.commit('courierModule/courierCatalogsLoaded', []);
    this.loadData();
  }
  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  @Watch('catalogs')
  protected onCatalogsChanged() {
    this.rows = this.catalogs.slice().sort((a, b) => a.position - b.position);
  }

  @Watch('countryId')
  protected onCountryChanged() {
    this.courierIdToAdd = null;
    this.rows = [];
    this.loadCatalogs();
  }

  protected loadData() {
    this.$store.dispatch('courierModule/fetchCouriers');
    this.loadCatalogs();
  }

  protected loadCatalogs() {
    if (!this.countryId) {
      return;
    }
    this.busy = true;
    this.$store.dispatch('courierModule/fetchCatalogs', this.countryId);
  }

  protected onAdd() {
    this.busy = true;
    this.$store.dispatch('courierModule/createCatalog', {countryId: this.countryId, courierId: this.courierIdToAdd});
  }

  protected onMove(index: number, direction: number) {
    const rows = this.rows.slice();
    const [moved] = rows.splice(index, 1);
    rows.splice(index + direction, 0, moved);
    this.rows = rows;
    this.busy = true;
    this.$store.dispatch('courierModule/reorderCatalogs', {countryId: this.countryId, ids: rows.map(each => each.id)});
  }

  protected onRemove(row: ICourierCatalog) {
    this.removingRow = row;
    this.removeShowing = true;
  }
  protected onRemoveConfirmed() {
    this.busy = true;
    this.$store.dispatch('courierModule/deleteCatalog', this.removingRow!.id);
  }

  private onLoaded() {
    this.busy = false;
  }
  private onChangedOK() {
    this.courierIdToAdd = null;
    this.removeShowing = false;
    this.$store.dispatch('courierModule/fetchCouriers');
    this.loadCatalogs();
  }
}

